"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAndParseEnvelope = exports.parseEnvelope = void 0;
var xml_utils_1 = require("xml-utils");
var utils_1 = require("../utils");
function parseEnvelope(xml) {
    var lowerCorner = (0, utils_1.findTagText)(xml, "gml:lowerCorner");
    var upperCorner = (0, utils_1.findTagText)(xml, "gml:upperCorner");
    if (!lowerCorner || !upperCorner) {
        throw new Error("unable to parse envelope");
    }
    var _a = __read(lowerCorner.split(" ").map(function (n) { return Number(n); }), 2), xmin = _a[0], ymin = _a[1];
    var _b = __read(upperCorner.split(" ").map(function (n) { return Number(n); }), 2), xmax = _b[0], ymax = _b[1];
    return [xmin, ymin, xmax, ymax];
}
exports.parseEnvelope = parseEnvelope;
function findAndParseEnvelope(xml) {
    var _a;
    var envelope = (_a = (0, xml_utils_1.findTagByName)(xml, "gml:Envelope")) === null || _a === void 0 ? void 0 : _a.outer;
    return envelope ? parseEnvelope(envelope) : undefined;
}
exports.findAndParseEnvelope = findAndParseEnvelope;
